import { Component, Input } from '@angular/core';
import { Package } from "src/app/dto";

@Component({
  selector: 'app-package-card',
  templateUrl: './package-card.component.html',
  styleUrls: ['./package-card.component.scss']
})
export class PackageCardComponent {
  @Input() product!: Package;

  // Add to component class
  handleIconError(event: any) {
    // Set a fallback icon if the SVG fails to load
    event.target.src = '/assets/data/specs/fallback.svg';
  }

  getIconPath(iconName: string): string {
    return `/assets/data/specs/${iconName}.svg`;
  }

  getPackageImagePath(imageName: string): string {
    return `/assets/data/phones/${imageName}`;
  }
}